(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["alma-pdp-loader"] && !Shopify.designMode) return;
  try {
    // Shopify bundles this definition once. A newly added section can load its
  // own module even when the first page contained no ALMA section.
  if (!customElements.get('alma-pdp-loader')) {
    customElements.define('alma-pdp-loader', class extends HTMLElement {
      connectedCallback() {
        if (this.loading || !this.dataset.module) return;
        this.loading = true;
        import(this.dataset.module).catch(() => { this.loading = false; });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
